import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const state = {
  projects : {}
}

export const mutations = {
  SET_PROJECTS(state, value) {
    state.projects = value
  }
}

export const getters = {
  getProjectFields() {
    return { model: 'plans_project', 
            label: 'Projects',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              { key: 'description', label: 'Description', type: 'textfield', sortable: true, required: false },
              // { key: 'project_manager_name', label: 'ProjectManager', type: 'text', sortable: true, required: false, visible: false },
              { key: 'line', label: 'Line', type: 'model', 
                model_source: 'Lines', model_route: 'management/masters/lines', 
                sortable: true, required: true, formatter: (value, key, item) => {
                return item.line.instance__name || item.line.name
              }},
              { key: 'activities', label: 'Activities', type: 'array_model', 
                model_source: 'Activities', model_route: 'management/masters/activities', 
                sortable: true, required: true, 
                formatter: (value, key, item) => {
                  return item.activities.length
                }
              },
              { key: 'project_manager', label: 'ProjectManager', type: 'model', 
                model_source: 'Users', model_route: 'management/users', model_query: '&groups__name=Coordinadores', 
                sortable: true, required: true, 
                formatter: (value, key, item) => {
                  return item.project_manager_name.full_name
                }
              }
            ]}
  },
  getProjectsLength(state) {
    return state.projects.length
  },
  getProjects(state) {
    return state.projects
  }
}

export const actions = {
  async fetchProjects({ commit, state }, query = '') {
    
    return axios
      .get(`${serverUrl}/api/masters/projects/${query}`)
      .then((response) => {
        commit('SET_PROJECTS', response.data)
        return response.data;
      })
  },

  async createProjects({ commit, state }, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/projects/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateProjects(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/projects/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteProjects(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/projects/${id}/`)
      .then((response) => {
        return response.data;
      })
  },

  fetchProjectsOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/api/masters/projects/${query}`).then((response) => {
      return response.data
    })
  },
}